/**
 * Base actions
 */

export const SHOW_DOCUMENT: string = 'SHOW_DOCUMENT';
export const CLEAR_CURRENT_DOCUMENT: string = 'CLEAR_CURRENT_DOCUMENT';

export const FETCH_SCHEMA: string = 'FETCH_SCHEMA';
export const FETCH_SCHEMA_SUCCESS: string = 'FETCH_SCHEMA_SUCCESS';
export const FETCH_SCHEMA_ERROR: string = 'FETCH_SCHEMA_ERROR';
export const FETCH_CURRENT_LIST: string = 'FETCH_CURRENT_LIST';
export const FETCH_LIST: string = 'FETCH_LIST';
export const FETCH_LIST_SUCCESS: string = 'FETCH_LIST_SUCCESS';
export const FETCH_LIST_ERROR: string = 'FETCH_LIST_ERROR';

export const BULK_UPDATE: string = 'BULK_UPDATE';
export const BULK_UPDATE_SUCCESS: string = 'BULK_UPDATE_SUCCESS';
export const BULK_UPDATE_ERROR: string = 'BULK_UPDATE_ERROR';

export const GET_ENTITY_CAPTIONS_SUCCESS: string =
  'GET_ENTITY_CAPTIONS_SUCCESS';

export const FETCH_GET_DOCUMENT_BY_ID: string = 'FETCH_GET_DOCUMENT_BY_ID';
export const FETCH_GET_DOCUMENT_BY_ID_SUCCESS: string =
  'FETCH_GET_DOCUMENT_BY_ID_SUCCESS';
export const FETCH_GET_DOCUMENT_BY_ID_ERROR: string =
  'FETCH_GET_DOCUMENT_BY_ID_ERROR';

export const DELETE_DOCUMENT_BY_ENTITY_ID: string =
  'DELETE_DOCUMENT_BY_ENTITY_ID';
export const DELETE_DOCUMENT_BY_ENTITY_ID_SUCCESS: string =
  'DELETE_DOCUMENT_BY_ENTITY_ID_SUCCESS';
export const DELETE_DOCUMENT_BY_ENTITY_ID_ERROR: string =
  'DELETE_DOCUMENT_BY_ENTITY_ID_ERROR';

export const FETCH_CREATE_ENTITY: string = 'FETCH_CREATE_ENTITY';
export const FETCH_CREATE_ENTITY_SUCCESS: string =
  'FETCH_CREATE_ENTITY_SUCCESS';
export const FETCH_CREATE_ENTITY_ERROR: string = 'FETCH_CREATE_ENTITY_ERROR';

export const FETCH_UPDATE_ENTITY: string = 'FETCH_UPDATE_ENTITY';
export const FETCH_UPDATE_ENTITY_SUCCESS: string =
  'FETCH_UPDATE_ENTITY_SUCCESS';
export const FETCH_UPDATE_ENTITY_ERROR: string = 'FETCH_UPDATE_ENTITY_ERROR';

export const STORE_CLEAR_ITEMS: string = 'STORE_CLEAR_ITEMS';
export const STORE_UPDATE_DOCUMENT: string = 'STORE_UPDATE_DOCUMENT';
export const STORE_UPDATE_DATA: string = 'STORE_UPDATE_DATA';

export const FORM_VALUE_CHANGED: string = 'FORM_VALUE_CHANGED';
export const FORM_STATUS_CHANGED: string = 'FORM_STATUS_CHANGED';

export const STORE_ORDER_STATUS: string = 'STORE_ORDER_STATUS';

export const REFERENCE_DATA_REQUIRED: string = 'REFERENCE_DATA_REQUIRED';

/**
 * @deprecated use STORE_UPDATE_ITEM instead
 * maybe we are not using this anywhere
 */
export const STORE_UPDATE_ITEM: string = 'STORE_UPDATE_ITEM';
